import { render, staticRenderFns } from "./BidApply.vue?vue&type=template&id=c831651a"
import script from "./BidApply.vue?vue&type=script&lang=js"
export * from "./BidApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports